<div class="flex">
  <sbnb-subnav [header]="'OPERATIONS.OPERATIONS' | transloco">
    <sbnb-operations-subnav></sbnb-operations-subnav>
    <sbnb-helptext-wrapper [area]="'sidebar'" [pageId]="'my-business-businesses'"></sbnb-helptext-wrapper>
  </sbnb-subnav>

  <main class="flex flex-1 subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <div class="w-full relative">
      <app-feature-flag-tabs class="w-full">
        <ng-container navTabs>
          <sbnb-page-header [parentPath]="'menu-mobile/ops-mobile'" class="absolute top-0 left-0"></sbnb-page-header>
          <div class="flex justify-center items-center flex-col sbnbDesktop:flex-row sbnbDesktop:justify-start gap-2">
            <h2 class="flex-1">Businesses</h2>
            <sbnb-button
              *ngIf="(businesses$ | async)?.data?.length !== 0"
              routerLink="new"
              size="mini"
              label="+ Add Business"></sbnb-button>
          </div>
        </ng-container>
        <div class="flex">
          <h2 class="flex-1">Businesses</h2>
          <sbnb-button
            *ngIf="(businesses$ | async)?.data?.length !== 0"
            routerLink="new"
            size="mini"
            label="+ Add Business"></sbnb-button>
        </div>
      </app-feature-flag-tabs>

      <ng-container *ngIf="businesses$ | async as businesses">
        <mat-table *ngIf="businesses.data?.length > 0; else noBusinesses" [dataSource]="businesses.data">
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
            <mat-cell *matCellDef="let row">{{ row.name }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="type">
            <mat-header-cell *matHeaderCellDef>Type</mat-header-cell>
            <mat-cell *matCellDef="let row">{{ row.type | humanize }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="properties">
            <mat-header-cell *matHeaderCellDef>Properties</mat-header-cell>
            <mat-cell *matCellDef="let row">
              <sbnb-avatar-group [items]="row.properties"></sbnb-avatar-group>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
          <mat-row
            class="hover:bg-smoke-lighter cursor-pointer"
            *matRowDef="let row; columns: columns"
            [routerLink]="['./', row.uuid]"></mat-row>
        </mat-table>
        <ng-template #noBusinesses>
          <sbnb-no-items
            text="Build a strong foundation for your scaling business 🚀"
            subtext="Whether you're managing your own rentals or handling properties for others, setting up your business the right way from day one is the key to long-term success. With streamlined accounting and customizable metrics tailored to your unique business model, you'll stay organized, maximize profits, and gain the insights you need to grow with confidence. "
            [buttons]="[{ id: 'new', label: '+ Add a new business', size: 'mini' }]"
            (button)="routeToNew()"></sbnb-no-items>
        </ng-template>
      </ng-container>
    </div>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Operations'">
  <sbnb-operations-subnav></sbnb-operations-subnav>
</sbnb-mobile-sidebar>
